import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import logo from '../logo.png';

export const imageToBase64 = async (imagePath) => {
  const response = await fetch(imagePath);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsDataURL(blob);
  });
};

export const exportExcel = async (
  data = [],
  filename = 'Reporte',
  options = {}
) => {
  try {
    const {
      escuela = 'Centro De Estudios Universitarios F. J. Múgica',
      titulo = 'Reporte de alumnos',
      logoBase = await imageToBase64(logo),
    } = options;

    if (!data || data.length === 0) {
      console.warn('No hay datos');
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reporte');

    // =====================================================
    // LOGO
    // =====================================================
  

    if (logoBase) {
      const imageId = workbook.addImage({
        base64: logoBase,
        extension: 'png',
      });

      worksheet.addImage(imageId, {
        tl: { col: 0, row: 0 },
        ext: { width: 80, height: 80 },
      });
    }

    // =====================================================
    // TITULOS
    // =====================================================

    worksheet.mergeCells('C1:J1');
    worksheet.getCell('C1').value = escuela;

    worksheet.getCell('C1').font = {
      bold: true,
      size: 18,
    };

    worksheet.getCell('C1').alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };

    worksheet.mergeCells('C2:J2');
    worksheet.getCell('C2').value = titulo;

    worksheet.getCell('C2').font = {
      bold: true,
      size: 14,
    };

    worksheet.getCell('C2').alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };

    worksheet.getRow(1).height = 35;
    worksheet.getRow(2).height = 25;

    // =====================================================
    // CONFIGURAR COLUMNAS SIN HEADERS
    // =====================================================

    const keys = Object.keys(data[0]);

    worksheet.columns = keys.map((key) => ({
      key,
      width: 25,
    }));

    // =====================================================
    // HEADER TABLA
    // =====================================================

    const headerRowNumber = 6;

    const headerRow = worksheet.getRow(headerRowNumber);

    keys.forEach((key, index) => {
      const cell = headerRow.getCell(index + 1);

      cell.value = key;

      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '1F4E78' },
      };

      cell.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      };

      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    headerRow.height = 25;

    // =====================================================
    // DATOS
    // =====================================================

    data.forEach((item) => {
      worksheet.addRow(item);
    });

    // =====================================================
    // BORDES DATOS
    // =====================================================

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber >= headerRowNumber + 1) {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
      }
    });

    // =====================================================
    // AUTOFILTRO
    // =====================================================

    worksheet.autoFilter = {
      from: {
        row: headerRowNumber,
        column: 1,
      },
      to: {
        row: headerRowNumber,
        column: keys.length,
      },
    };

    // =====================================================
    // CONGELAR ENCABEZADO
    // =====================================================

    worksheet.views = [
      {
        state: 'frozen',
        ySplit: headerRowNumber,
      },
    ];

    // =====================================================
    // EXPORTAR
    // =====================================================

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${filename}.xlsx`);
  } catch (error) {
    console.error(error);
  }
};